import type { MergeModelsRequest, MergeModelsResponse } from '@rock/types';
import { MergeModelsResponseSchema } from '@rock/types';
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Merge one model into another, server-side (`mergeModels`). `dryRun: true` returns the counts the confirm
 * step shows; the real run returns the receipt. A refusal (self-merge, a missing or archived model, a loser
 * already merged) comes back as a status, not an error.
 */
export async function mergeModels(request: MergeModelsRequest): Promise<MergeModelsResponse> {
    // Units span homes and move one by one; the client default of 70 s could give up before the server.
    const fn = httpsCallable<MergeModelsRequest, MergeModelsResponse>(getFunctions(), 'mergeModels', {
        timeout: 540_000,
    });
    const result = await fn(request);
    return MergeModelsResponseSchema.parse(result.data);
}
